async function getServiceWorkerFilename() {
    try {
        const manifestResponse = await fetch('/sw-manifest.json');
        const manifest = await manifestResponse.json();
        return manifest.filename;
    } catch (error) {
        console.error('Error loading SW manifest:', error);
        return 'sw.js'; // Fallback to sw.js if there's an error
    }
}

if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
        try {
            const swFilename = await getServiceWorkerFilename();
            const registration = await navigator.serviceWorker.register(`/${swFilename}`, {
                scope: '/',
                type: 'module'
            });
            console.log('ServiceWorker registration successful with:', swFilename, 'scope=/', 'type=module');
        } catch (error) {
            console.error('ServiceWorker registration failed:', error);
        }
    });
}